import React, { useState } from 'react';
import axios from 'axios';
import { errorMessage } from '../../utils/staffDocuments';
import { formatDate } from '../../utils/dates';
import { useToast } from '../ui';
import './staffDocuments.css';

// Staff sign by typing their full name
export default function SignBox({ doc, signed, online, onSigned }) {
  const toast = useToast();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  if (signed) {
    return (
      <div className="bk-card coc-sign coc-sign--done">
        <span className="bk-pill bk-pill--good">Signed</span>
        <p>You signed this version as {signed.fullName} on {formatDate(signed.signedAt)}.</p>
      </div>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await axios.post(`/api/staff-documents/${doc.id}/sign`, { version: doc.version, fullName: name.trim() });
      toast('Document signed');
      onSigned(res.data);
    } catch (err) {
      setError(errorMessage(err, "Couldn't sign. Try again."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="bk-card coc-sign sd-sign" onSubmit={submit}>
      <h3>Sign</h3>
      <p>{doc.declaration}</p>
      <label className="bk-label" htmlFor="coc-name">Type your full name</label>
      <input id="coc-name" className="bk-input" value={name} onChange={e => setName(e.target.value)} autoComplete="name" />
      {error && <p className="bk-form-error" role="alert">{error}</p>}
      {!online && <p className="bk-small">Signing needs signal.</p>}
      <button type="submit" className="bk-btn bk-btn--primary bk-btn--full" disabled={busy || !online || name.trim().length < 2}>
        {busy ? 'Signing…' : 'Sign'}
      </button>
    </form>
  );
}
